import controlIcon from "../../../assets/images/program/control.svg";
import imsIcon from "../../../assets/images/program/ims.svg";
import pmsIcon from "../../../assets/images/program/panorama.svg";
import weatherIcon from "../../../assets/images/program/weather.svg";
import pilotIcon from "../../../assets/images/program/pilot.svg";

export enum LicenseType {
    PILOT = 100,
    PMS = 101,
    CONTROL_SYSTEM = 102,
    IMS = 103,
    WEATHER = 104
}

export const LicenseTypeList = [
    {
        type: LicenseType.PILOT,
        name: "DFOS Pilot",
        icon: pilotIcon,
        isFree: true
    },
    {
        type: LicenseType.PMS,
        name: "DFOS PMS",
        icon: pmsIcon,
        isFree: false
    },
    {
        type: LicenseType.CONTROL_SYSTEM,
        name: "DFOS Control System",
        icon: controlIcon,
        isFree: false
    },
    {
        type: LicenseType.IMS,
        name: "DFOS IMS",
        icon: imsIcon,
        isFree: false
    },
    {
        type: LicenseType.WEATHER,
        name: "DFOS Weather",
        icon: weatherIcon,
        isFree: true
    }
];